import { GET, POST } from '../request'
export default {
  /*  */
  getProductCenter: data => {
    return GET('/product/center', data)
  },
  getProductTypeList: data => { // 商品分类
    return GET('/productSort/listProductSort', data)
  },
  getProductList: data => { // 商品列表
    return POST('/product/hardware/page', data)
  },
  getSoftWareSystemsList: data => { // 软件列表
    return POST('/softwareSystem/pageSoftWareSystems', data)
  },
  getProductInfoForCompare: data => { // 同类型下的商品比较
    return GET('/product/hardware/getProductInfoForCompare', data)
  },
  getPageProductInfoBySort: data => { // 分页获取同类型下的所有商品
    return POST('/product/hardware/getPageProductInfoBySort', data)
  },
  getProductInfo: data => { // 获取硬件产品详情
    return GET('/product/hardware/getProductInfo', data)
  },
  getSoftWareSystemDetail: data => { // 获取软件系统详情
    return POST('/softwareSystem/getSoftWareSystemDetail', data)
  },
  getAreaListByParentId: data => { // 获取省市
    return GET('/order/getAreaListByParentId', data)
  },
  addOrder: data => { // 提交订单
    return POST('/order/addOrder', data)
  }
}
